import React, {useContext} from 'react';

export const SearchContext = React.createContext<string>(null);

export function useSearchTerm() {
    return useContext(SearchContext);
}
